import { SupportedLocale, SUPPORTED_LOCALES } from './types'

export const isSupportedLocale = (locale: string): locale is SupportedLocale =>
  // NEEDS TO BE ADDED LATER TO SUPPORTED LOCALES VIA POEDITOR
  [...SUPPORTED_LOCALES, 'ja', 'fr', 'ko'].includes(locale as SupportedLocale)
